import React from 'react'

const autoStyle1 = {position:"fixed", height:"100%", width:"100%", zIndex:10, top: "0px", left:"0px"};

export default function OverLayComponent() {
  return (<div className="over-lay-component" style={autoStyle1}></div>);
}
